export class Address {
  street: string;
  street2: string;
  city: string;
  state: string;
  country: string;
  zipcode: string;
  displayName: string;
}
